// extracted by mini-css-extract-plugin
module.exports = {"week_day":"SelectWeekDay_week_day__2x3Oz","selected":"SelectWeekDay_selected__16PFy"};